import { render, staticRenderFns } from "./videoCourseTabList.vue?vue&type=template&id=3d0ab18b&"
import script from "./videoCourseTabList.vue?vue&type=script&lang=js&"
export * from "./videoCourseTabList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports